import { render, staticRenderFns } from "./phone-binding.vue?vue&type=template&id=1a104830&lang=pug&"
import script from "./phone-binding.vue?vue&type=script&lang=js&"
export * from "./phone-binding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports